









































import { Prop, Component, Mixins } from 'vue-property-decorator';
import InputMixin from '../private/InputMixin';

@Component
export default class AbcSelect extends Mixins(InputMixin) {
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: null }) info!: string | null;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) buttons!: boolean;

    private haveFocus = false;
    private haveHover = false;

    private get currentValue(): unknown {
        return this.value;
    }

    private set currentValue(val: unknown) {
        this.runRules(val);
        this.$emit("input", val);
    }

    private get wrapperClass(): { [key: string]: boolean } {
        return {
            "border-border dark:border-border-dark": !this.haveHover && !this.haveFocus && !this.haveErrors,
            "border-secondary-300": ((this.haveHover || this.haveFocus) && !this.isDisabled) && !this.haveErrors,

            "border-danger-400 dark:border-danger-dark-400": !!this.haveErrors,
            "border-danger-500 dark:border-danger-dark-500": ((this.haveHover || this.haveFocus) && !this.isDisabled) && !!this.haveErrors,

            "abc-select-focused": this.haveFocus && !this.haveErrors,
            "abc-select-focused-error": this.haveFocus && !!this.haveErrors,

            "bg-bg-100 dark:bg-bg-dark-100": !this.isDisabled,
            "bg-bg-500 dark:bg-bg-dark-500 text-label-primary dark:text-label-primary-dark": this.isDisabled,
        };
    }

    private focusChanged(on: boolean) {
        this.haveFocus = on;
        if (!on) {
            this.runRules(this.value);
        }
    }

}
